import React from "react";
import Link from "gatsby-link";

const OrderButton = ({ onToggle, text, link, linkType, onClick }) => {
  return linkType === "a" ? (
    <a to={link} href={link} target="_blank">
      <button className="order-button" onClick={onToggle}>
        <span id="order-button-content">{text}</span>
      </button>
    </a>
  ) : (
    <Link to={link} href={link} onClick={onClick}>
      <button className="order-button" onClick={onToggle}>
        <span id="order-button-content">{text}</span>
      </button>
    </Link>
  );
};

export default OrderButton;



// WEBPACK FOOTER //
// ./src/components/Navigation/OrderButton.jsx